import { CPD_LOCALSTORAGE_KEY } from './constants';

export function setCPDTimestamp() {
  if (window.localStorage) {
    const now = new Date();
    const msFrom1970 = now.getTime();

    window.localStorage.setItem(CPD_LOCALSTORAGE_KEY, String(msFrom1970));
  }
}
